// extracted by mini-css-extract-plugin
export default {"shipment-table__wrapper":"SalesOrderTable_shipment-table__wrapper__jWvV3","shipment-table":"SalesOrderTable_shipment-table__vqIiu"};